import React, { FC } from 'react'
import classNames from 'classnames'
import equal from 'fast-deep-equal'
import styles from 'styles/components/card.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { OrderCardBodySummaryLabel } from 'components/Card'
import { LightTag } from 'components/Tag'
import HTMLReactParser from 'html-react-parser'
import { parseDeliveryCompany, returnCodeToBr } from 'lib/helper'
import { FlexRow } from 'components/Flex'
import { CheckoutChannel, CheckoutChannelMap } from 'types/checkout'

type Props = {
  amount: number
  checkoutChannel?: CheckoutChannel
  deliveryCompany: string
  deliveryFeeAmount: number
  discountAmount: number
  isFrozenDelivery: boolean
  orderLabel: string
  request: string
}

const DeliveryOrderCardBodySummary: FC<Props> = React.memo(
  (props) => {
    const {
      amount,
      checkoutChannel,
      deliveryCompany,
      deliveryFeeAmount,
      discountAmount,
      isFrozenDelivery,
      orderLabel,
      request,
    } = props
    return (
      <div className={styles.order__body__summary}>
        <FlexRow justifyContent={'start'}>
          <img src={'/icon/green/order.svg'} alt={'注文時刻'} />
          <Spacer size={4} />
          <span className={classNames(text.font_small)}>{orderLabel}</span>
        </FlexRow>
        <Spacer size={8} />
        <OrderCardBodySummaryLabel label={'注文タイプ'}>
          <LightTag color={'orange'} label={'取り寄せ'} />
        </OrderCardBodySummaryLabel>
        <Spacer size={8} />
        <OrderCardBodySummaryLabel label={'配送方法'}>
          <p className={text.font_small}>
            {parseDeliveryCompany(deliveryCompany)} / {isFrozenDelivery ? 'クール便' : '通常配送'}
          </p>
        </OrderCardBodySummaryLabel>
        <Spacer size={8} />
        <OrderCardBodySummaryLabel label={'購入経路'}>
          <p className={text.font_small}>{checkoutChannel ? CheckoutChannelMap[checkoutChannel] : 'アプリ'}</p>
        </OrderCardBodySummaryLabel>
        <Spacer size={8} />
        <OrderCardBodySummaryLabel label={'売上(税込)'}>
          <p className={text.font_small}>{amount.toLocaleString()}円</p>
        </OrderCardBodySummaryLabel>
        <Spacer size={8} />
        <OrderCardBodySummaryLabel label={'うち配送料'}>
          <p className={text.font_small}>{deliveryFeeAmount.toLocaleString()}円</p>
        </OrderCardBodySummaryLabel>
        {discountAmount !== 0 && (
          <>
            <Spacer size={8} />
            <OrderCardBodySummaryLabel label={'クーポン'}>
              <p className={text.font_small}>-{discountAmount.toLocaleString()}円</p>
            </OrderCardBodySummaryLabel>
          </>
        )}
        {request && request !== '' && (
          <>
            <Spacer size={8} />
            <p className={`${text.font_small} ${text.color_grey_01}`}>{'お客さまからのご要望：'}</p>
            <Spacer size={4} />
            <p className={text.font_small}>{HTMLReactParser(returnCodeToBr(request))}</p>
          </>
        )}
      </div>
    )
  },
  (prev, next) => equal(prev, next)
)

export default DeliveryOrderCardBodySummary
